export default __webpack_public_path__ + "static/media/energia.e8666106.jpg";